import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { uniqBy } from '@shared/utils/helpers/uniqBy';
import { isNonNullable } from '../../../../../utils/helpers/type-compatible-filter-functions';
import { type LearnCarouselCardData } from '../../../actions/types';
export type UseCarouselMagazineIssueFilterProps = {
  cards: LearnCarouselCardData[];
  showMagazineIssueFilter: boolean;
};
type MagazineIssueFilterValue = {
  month: number;
  year: number;
};
export const useCarouselMagazineIssueFilter = t0 => {
  const $ = _c(12);
  const {
    cards,
    showMagazineIssueFilter
  } = t0;
  const sortedMagazineIssues = showMagazineIssueFilter ? uniqBy(cards.map(_temp).filter(isNonNullable), _temp2).sort(_temp3) : [];
  const [currentMagazineIssueFilter, setCurrentMagazineIssueFilter] = useState(sortedMagazineIssues?.[0] ?? null);
  const locale = useLocale();
  const readableFormat = new Intl.DateTimeFormat(locale, {
    month: "short",
    year: "numeric"
  });
  const ariaFormat = new Intl.DateTimeFormat(locale, {
    month: "long",
    year: "numeric"
  });
  if (!showMagazineIssueFilter) {
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [];
      t2 = [];
      $[0] = t1;
      $[1] = t2;
    } else {
      t1 = $[0];
      t2 = $[1];
    }
    let t3;
    if ($[2] !== setCurrentMagazineIssueFilter) {
      t3 = {
        filterCardsBySelectedMagazineIssue: _temp4,
        magazineIssueFilterDisplayedItems: t1,
        magazineIssueFilterDropdownItems: t2,
        setCurrentMagazineIssueFilter
      };
      $[2] = setCurrentMagazineIssueFilter;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const filterItems = sortedMagazineIssues.map(issue_0 => {
    const dateFrom = new Date(issue_0.year, issue_0.month - 1);
    const dateTo = new Date(issue_0.year, issue_0.month);
    return {
      ariaLabel: ariaFormat.formatRange(dateFrom, dateTo),
      label: readableFormat.formatRange(dateFrom, dateTo),
      selected: currentMagazineIssueFilter?.year === issue_0.year && currentMagazineIssueFilter?.month === issue_0.month,
      value: issue_0
    };
  });
  let t1;
  if ($[4] !== currentMagazineIssueFilter) {
    t1 = cardsArgument_0 => currentMagazineIssueFilter ? cardsArgument_0.filter(card_0 => card_0.MagazineIssueMonth === currentMagazineIssueFilter?.month && card_0.MagazineIssueYear === currentMagazineIssueFilter?.year) : cardsArgument_0;
    $[4] = currentMagazineIssueFilter;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = filterItems.slice(0, 2);
  const t3 = filterItems.slice(2);
  let t4;
  if ($[6] !== currentMagazineIssueFilter || $[7] !== setCurrentMagazineIssueFilter || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      currentMagazineIssueFilter,
      filterCardsBySelectedMagazineIssue: t1,
      magazineIssueFilterDisplayedItems: t2,
      magazineIssueFilterDropdownItems: t3,
      setCurrentMagazineIssueFilter
    };
    $[6] = currentMagazineIssueFilter;
    $[7] = setCurrentMagazineIssueFilter;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(card) {
  return card.MagazineIssueYear && card.MagazineIssueMonth ? {
    month: card.MagazineIssueMonth,
    year: card.MagazineIssueYear
  } : null;
}
function _temp2(issue) {
  return `${issue.year} ${issue.month}`;
}
function _temp3(issue1, issue2) {
  if (issue1.year !== issue2.year) {
    return issue2.year - issue1.year;
  }
  return issue2.month - issue1.month;
}
function _temp4(cardsArgument) {
  return cardsArgument;
}